import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormArray, FormControl, FormGroup, FormRecord, NonNullableFormBuilder, Validators } from "@angular/forms";
import { WebhookField } from "../../webhook-interfaces/configuration";
import { Variable } from "src/app/forms/formula-tester/formula-tester.component";
import { WebHookCommonServices } from "../../webhook-services/webhook-commom.services";

import { FormServices } from "src/app/services/form.services";
import { NzModalService } from "ng-zorro-antd/modal";
import { Subscription } from "rxjs";
import { LanguageServices } from "src/app/services/LanguageServices";


@Component({
    selector: 'webhook-form-table',
    templateUrl: './webhook-form-table.component.html',
    styleUrl: './webhook-form-table.component.scss',
    standalone: false,
})

export class WebhookFormTableComponent implements OnInit {
    formRows: number[];
     constructor(
            protected fb:NonNullableFormBuilder, 
            protected cd:ChangeDetectorRef,
            protected commomServices:WebHookCommonServices,
            protected fs:FormServices,
            protected modal:NzModalService,
            protected ls: LanguageServices
        
        ) {

    }

    
    editMode:boolean = false;
    private editIndex: number | null = null;

    pageIndex:number = 1;
    pageSize:number = null;
    newRow = this.fb.group({});
    @Input() mainformGroup:FormGroup;
    @Input() field:WebhookField;
    @Input() fieldNew:string;
    @Input() variables:Variable[] = [];
    @Input() rootForm:FormGroup;
    @Input() configuration: any;
    @Input() n:number=0;
    showAction:boolean = true;
    showAdd:boolean = true;
    showRemove:boolean = true;
    sub1:Subscription;
    controlEntries: { key: string; control: FormControl<any> }[] = [];
    

    ngOnDestroy(): void {   
        if (this.sub1!=null) {    
            this.sub1.unsubscribe();
        }
    }

    ngOnInit(): void {
        
        this.pageSize = this.field.tableConfiguration.pageSize == null ? 3 :this.field.tableConfiguration.pageSize;

        if ( this.field.tableConfiguration.showAdd!= null ){
            this.showAdd = this.field.tableConfiguration.showAdd;
        }

        if ( this.field.tableConfiguration.showRemove!= null ){
            this.showRemove = this.field.tableConfiguration.showRemove;
        }

        if ( !this.showRemove && !this.showAdd){
            this.showAction = false;
        }
            

        this.formRows = [...new Set(this.field.tableConfiguration.fields.map(item => item.row))];

        this.newRow = this.createEmptyRow(); 
        this.fieldNew = this.field.field.split('.')[this.n];
               
    }

    OnDestroy(): void {
        this.field['editing'] = false;
    }

    addNewRow(){
        this.newRow.reset();
        this.editIndex = null;
        this.editMode = true;
        this.field['editing'] = true;

    }

    get rows(){
        return (this.mainformGroup.get(this.fieldNew) as FormArray);
    }

    get pagedRows() {

        const start = (this.pageIndex - 1) * this.pageSize;
        if ( this.rows!=null){
            this.prepareRows(this.rows);
        }
        if ( this.rows==null || this.rows.controls.length==0){
            return [];
        }
        return this.rows.controls.slice(start, start + this.pageSize);
        
    }

    clearRow(){
        this.newRow.reset();
        this.field['editing'] = false;
    }

    prepareRows(rows:FormArray<any>){
        const expectedFields = this.field.tableConfiguration.fields;
        
        // rows.controls.forEach((fg: FormGroup) => {
        //     expectedFields.forEach(field => { 
        //         try{
        //             this.commomServices.createControl(field,fg);
        //         }catch(Error){
        //             console.error("Error creating control for field:", field, "in form group:", fg.controls);
        //         }
                
        //     });
        // });
    }

    
    saveRow() {
        
        if (this.newRow.valid) {
            
            const clone = this.cloneFrom(this.newRow); // never push newRow directly

            if (this.editIndex !== null) {
                this.rows.setControl(this.editIndex,clone); // update existing
            } else {
                this.rows.push(clone); // insert new
            }

           this.cd.detectChanges();

            const total = this.rows.length;
            const pages = Math.ceil(total / this.pageSize);
            this.pageIndex = pages;


            this.newRow.reset();
            this.editMode = false;
            this.field['editing'] = false;
        }else{
            this.commomServices.showError(this.field.tableConfiguration.fields, this.newRow);
        }
    }
    

    removeRow(index: number) {
        this.rows.removeAt(index);
        this.mainformGroup.setControl(this.fieldNew, this.fb.array([...this.rows.controls]));
        const totalItems = this.rows.length;
        const totalPages = Math.max(1, Math.ceil(totalItems / this.pageSize));

        this.pageIndex = Math.min(this.pageIndex, totalPages);
        this.field['editing'] = false;
        this.cd.detectChanges();
    }


    editRow(absoluteIndex: number): void {

        let index:number = (this.pageIndex - 1) * this.pageSize + absoluteIndex;
        let rowGroup:FormGroup<any> = this.rows.at(index) as FormGroup<any>;
        this.newRow = this.createEmptyRow();
        this.fs.patchForm(rowGroup.getRawValue(),this.newRow);   
        
        this.editIndex = index;
        this.editMode = true;
        this.field['editing'] = true;
    }



    private createEmptyRow(): FormGroup {
        const g = this.fb.group({});
        
        if ( this.field.tableConfiguration!=null && this.field.tableConfiguration.fields!=null){
            this.field.tableConfiguration.fields.forEach(f => {
                this.commomServices.createControl(f, g);
            });
        }

        g.addControl('editing', new FormControl<boolean>(false, { nonNullable: true }));
        g.addControl('component', new FormControl<Object>(this.field));
 
        return g;
    }

    private cloneFrom(source: FormGroup): FormGroup {
        const g = this.createEmptyRow();
        //g.patchValue(source.getRawValue());
        this.fs.patchForm(source.getRawValue(),g);    
        return g;
    }


      loadData(){
        if ( this.field.tableConfiguration.loadDataConfiguration?.query!=null){
            if ( this.field.tableConfiguration.loadDataConfiguration.type == null || this.field.tableConfiguration.loadDataConfiguration.type =='query'){
                
                this.commomServices.getDataNativeQuery(this.field.tableConfiguration.loadDataConfiguration.query, this.variables).then(data=>{
                    if ( data){
                        if ( this.rows.length > 0 ){
                                this.modal.warning({
                                nzTitle:this.ls.instant('workflow.loaddata.title'),
                                nzContent:this.ls.instant('workflow.loaddata.question'),
                                nzOkText: this.ls.instant('confirm'),
                                nzOkDanger: true,
                                nzCancelText: this.ls.instant('cancel'),
                                nzOnOk: () => {
                                    this.refreshData(data as Object[]);
                                }
                            });
                        }else{
                            this.refreshData(data as Object[]);
                        }
                    }
            
                }).catch(error=>{
                    throw error;
                });
            }
        }
    }

    refreshData(data:Object[]){
        this.rows.clear();
        for (var line of data){   
            Object.keys(line).forEach(key=>{
                if ( this.field.tableConfiguration.loadDataConfiguration.relation == null ){
                    if ( this.newRow.get(key)!=null){
                        this.newRow.get(key).setValue(line[key]);
                    }   
                }else{
                    let relation:{from:string,to:string}[] =  this.field.tableConfiguration.loadDataConfiguration.relation;
                    let to:string  = relation.find(r=>r.from==key).to;
                    if ( this.newRow.get(to)!=null){
                        this.newRow.get(to).setValue(line[key]);
                    }  
                }
            });
    
            this.saveRow();
        }    
    }
}
